import axios from "axios";

// const API_BASE = `http://localhost:3000`;
const API_BASE = `https://evtapi.rmutl-research.com`;

export async function fetchHotspots(province) {
  const res = await axios.get(`${API_BASE}/firms?province=${province}`);
  return res.data;
}
